/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  fetchFormationInfochercher({ commit },obj) {
    return new Promise((resolve, reject) => {
      axios.post('https://trainingcenterback.codily.net/api/get_formation_info_chercher', obj)
        .then((response) => {
          console.log(obj)
          console.log(response.data)
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchFormationInfo({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("https://trainingcenterback.codily.net/api/getformationinfo")
        .then((response) => {
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchFormateurs({ commit },userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_formateur_formation_id/${userId}`)
        .then((response) => {
          commit('SET_FORMATEURS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchGroupes({ commit },userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_classes_formation_id/${userId}`)
        .then((response) => {
          commit('SET_GROUPES', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
   addItem({ commit }, item) {
     return new Promise((resolve, reject) => {
       axios.post("https://trainingcenterback.codily.net/api/addformation", item)
         .then((response) => {
           commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
           resolve(response)
         })
         .catch((error) => { reject(error) })
     })
   },
  fetchUsers({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("https://trainingcenterback.codily.net/api/getformation")
        .then((response) => {
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchNews({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("https://trainingcenterback.codily.net/api/getNewformation")
        .then((response) => {
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUser(context, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/getformation_id/${userId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchFormation({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/getformation_id/${userId}`)
        .then((response) => {
          console.log('cv',userId)
          console.log('cv',response.data)
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchClass({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_classes_formation_id/1`)
        .then((response) => {
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeRecord({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.delete(`https://trainingcenterback.codily.net/api/destroyformation/${userId}`)
        .then((response) => {
          commit('REMOVE_RECORD', userId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  
  updateRecord({ commit }, user) {
    return new Promise((resolve, reject) => {
      axios.post(`https://trainingcenterback.codily.net/api/updateformation/${user.id}`, user)
        .then((response) => {

          // Convert Date String to Date Object
          let user = response.data
          commit('UPDATE_USERS', user)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateavatarRecord({ commit }, user) {
    return new Promise((resolve, reject) => {
      axios.post(`https://trainingcenterback.codily.net/api/updateformationavatar/${user.id}`, user)
        .then((response) => {

          // Convert Date String to Date Object
          let user = response.data
          console.log("user",user)
          commit('UPDATE_USERS', user)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  /////////////formateur//////////////////////
  fetchFormationsFormateur({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_formation_formateur_id/${userId}`)
        .then((response) => {
          console.log('response.data',response.data)
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchClasseFormationIDFormateurID({ commit },obj) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_classe_formation_formateur_id/${obj.formateur}/${obj.formation}`)
        .then((response) => {
          /*console.log('obj.formaion',obj.formation)
          console.log('obj.formateur',obj.formateur)
          console.log('response.data',response.data)*/
          commit('SET_GROUPES', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  /////////////candidat//////////////////////
  fetchFormationsCandidat({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_formation_candidat_id/${userId}`)
        .then((response) => {
          console.log('response.data',response.data)
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchClasseFormationIDCandidatID({ commit },obj) {
    return new Promise((resolve, reject) => {
      axios.get(`https://trainingcenterback.codily.net/api/get_classe_formation_candidat_id/${obj.formateur}/${obj.formation}`)
        .then((response) => {
          /*console.log('obj.formaion',obj.formation)
          console.log('obj.formateur',obj.formateur)*/
          console.log('response.data',response.data)
          commit('SET_GROUPES', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
